module.exports = __webpack_public_path__ + "static/img/login-bg.60a0856f.jpeg";